'use client'

import { ReactPortal, useLayoutEffect, useState } from 'react'
import ReactDOM from 'react-dom'

type Props = {
  children: React.ReactNode
  selector: string
}

export const Portal = ({ children, selector }: Props): ReactPortal | null => {
  const [container, setContainer] = useState<Element | null>(null)

  useLayoutEffect(() => {
    const el = document.querySelector(selector)
    if (el) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setContainer(el)
      return
    }

    // Target not yet in DOM (e.g. inside a streamed Suspense boundary) — watch for it
    const observer = new MutationObserver(() => {
      const found = document.querySelector(selector)
      if (found) {
        setContainer(found)
        observer.disconnect()
      }
    })
    observer.observe(document.body, { childList: true, subtree: true })
    return () => observer.disconnect()
  }, [selector])

  if (!container) return null
  return ReactDOM.createPortal(children, container)
}
